import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Enfermeria/enfermeria';
import EnfermeriaGrid from './EnfermeriaGrid';

const mstp = state => {
    return {...state.enfermeria}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(EnfermeriaGrid)
